function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M246.30563,66.50485h-28.87054v-15.51526c0-4.41827-3.58173-8-8-8h-32.14105c-4.41833,0-8,3.58173-8,8v15.51526h-82.58807v-15.51526c0-4.41827-3.58173-8-8-8h-32.14111c-4.41827,0-8,3.58173-8,8v15.51526H9.69437c-4.41833,0-8,3.58167-8,8v130.50555c0,4.41827,3.58167,8,8,8h236.61127c4.41827,0,8-3.58173,8-8V74.50485c0-4.41833-3.58173-8-8-8ZM234.7963,190.50113c0,1.65686-1.34314,3-3,3H24.20364c-1.65686,0-3-1.34314-3-3v-101.487c0-1.65686,1.34314-3,3-3h207.59265c1.65686,0,3,1.34314,3,3v101.487Z",
  fill: "red"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 36.6114,
  y: 114.14004,
  width: 51.97673,
  height: 19.57643,
  rx: 3,
  ry: 3,
  fill: "red"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 167.33503,
  y: 114.14004,
  width: 51.97673,
  height: 19.57643,
  rx: 3,
  ry: 3,
  fill: "red"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 167.33503,
  y: 114.14004,
  width: 51.97673,
  height: 19.57643,
  rx: 3,
  ry: 3,
  transform: "translate(69.39514 317.25164) rotate(-90)",
  fill: "red"
});

var SvgWebappIconCarBatteryLow = function SvgWebappIconCarBatteryLow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWebappIconCarBatteryLow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webapp-icon-car-battery-low.f1a98699.svg";
export { ForwardRef as ReactComponent };